// extracted by mini-css-extract-plugin
module.exports = {"socialIcon":"SocialIcon_socialIcon__4WGM7","socialIconOutline":"SocialIcon_socialIconOutline__uJW3H","socialIconOutlineInverse":"SocialIcon_socialIconOutlineInverse___M5_Z"};